"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all3) => {
  for (var name in all3)
    __defProp(target, name, { get: all3[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod2) => __copyProps(__defProp({}, "__esModule", { value: true }), mod2);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  BaseError: () => BaseError,
  ChordNames: () => ChordNames,
  CoreError: () => CoreError,
  ENHARMONIC_FLAT_TO_SHARP: () => ENHARMONIC_FLAT_TO_SHARP,
  ENHARMONIC_SHARP_TO_FLAT: () => ENHARMONIC_SHARP_TO_FLAT,
  FRET_MARKER_POSITIONS: () => FRET_MARKER_POSITIONS,
  FretboardModel: () => FretboardModel,
  INSTRUMENTS_BY_TYPE: () => INSTRUMENTS_BY_TYPE,
  InstrumentType: () => InstrumentType,
  MusicTheoryService: () => MusicTheoryService,
  NotFoundError: () => NotFoundError,
  ScaleDisplayMode: () => ScaleDisplayMode,
  ScaleNames: () => ScaleNames,
  ValidationError: () => ValidationError,
  formatNote: () => formatNote,
  generateScaleVisualizationData: () => generateScaleVisualizationData,
  getCompleteScaleNotes: () => getCompleteScaleNotes,
  getScaleStepPatterns: () => getScaleStepPatterns
});
module.exports = __toCommonJS(index_exports);

// ../../node_modules/@tonaljs/collection/dist/index.mjs
function rotate(times, arr) {
  const len = arr.length;
  const n = (times % len + len) % len;
  return arr.slice(n, len).concat(arr.slice(0, n));
}
function compact(arr) {
  return arr.filter((n) => n === 0 || n);
}

// ../../node_modules/@tonaljs/pitch/dist/index.mjs
function isNamedPitch(src) {
  return src !== null && typeof src === "object" && "name" in src && typeof src.name === "string" ? true : false;
}
function isPitch(pitch2) {
  return pitch2 !== null && typeof pitch2 === "object" && "step" in pitch2 && typeof pitch2.step === "number" && "alt" in pitch2 && typeof pitch2.alt === "number" && !isNaN(pitch2.step) && !isNaN(pitch2.alt) ? true : false;
}
var FIFTHS = [0, 2, 4, -1, 1, 3, 5];
var STEPS_TO_OCTS = FIFTHS.map(
  (fifths) => Math.floor(fifths * 7 / 12)
);
function coordinates(pitch2) {
  const { step, alt, oct, dir = 1 } = pitch2;
  const f = FIFTHS[step] + 7 * alt;
  if (oct === void 0) {
    return [dir * f];
  }
  const o = oct - STEPS_TO_OCTS[step] - 4 * alt;
  return [dir * f, dir * o];
}
var FIFTHS_TO_STEPS = [3, 0, 4, 1, 5, 2, 6];
function pitch(coord) {
  const [f, o, dir] = coord;
  const step = FIFTHS_TO_STEPS[unaltered(f)];
  const alt = Math.floor((f + 1) / 7);
  if (o === void 0) {
    return { step, alt, dir };
  }
  const oct = o + 4 * alt + STEPS_TO_OCTS[step];
  return { step, alt, oct, dir };
}
function unaltered(f) {
  const i = (f + 1) % 7;
  return i < 0 ? 7 + i : i;
}

// ../../node_modules/@tonaljs/pitch-interval/dist/index.mjs
var fillStr = (s, n) => Array(Math.abs(n) + 1).join(s);
var NoInterval = Object.freeze({
  empty: true,
  name: "",
  num: NaN,
  q: "",
  type: "",
  step: NaN,
  alt: NaN,
  dir: NaN,
  simple: NaN,
  semitones: NaN,
  chroma: NaN,
  coord: [],
  oct: NaN
});
var INTERVAL_TONAL_REGEX = "([-+]?\\d+)(d{1,4}|m|M|P|A{1,4})";
var INTERVAL_SHORTHAND_REGEX = "(AA|A|P|M|m|d|dd)([-+]?\\d+)";
var REGEX = new RegExp(
  "^" + INTERVAL_TONAL_REGEX + "|" + INTERVAL_SHORTHAND_REGEX + "$"
);
function tokenizeInterval(str) {
  const m = REGEX.exec(`${str}`);
  if (m === null) {
    return ["", ""];
  }
  return m[1] ? [m[1], m[2]] : [m[4], m[3]];
}
var cache = {};
function interval(src) {
  return typeof src === "string" ? cache[src] || (cache[src] = parse(src)) : isPitch(src) ? interval(pitchName(src)) : isNamedPitch(src) ? interval(src.name) : NoInterval;
}
var SIZES = [0, 2, 4, 5, 7, 9, 11];
var TYPES = "PMMPPMM";
function parse(str) {
  const tokens = tokenizeInterval(str);
  if (tokens[0] === "") {
    return NoInterval;
  }
  const num = +tokens[0];
  const q = tokens[1];
  const step = (Math.abs(num) - 1) % 7;
  const t = TYPES[step];
  if (t === "M" && q === "P") {
    return NoInterval;
  }
  const type = t === "M" ? "majorable" : "perfectable";
  const name = "" + num + q;
  const dir = num < 0 ? -1 : 1;
  const simple = num === 8 || num === -8 ? num : dir * (step + 1);
  const alt = qToAlt(type, q);
  const oct = Math.floor((Math.abs(num) - 1) / 7);
  const semitones2 = dir * (SIZES[step] + alt + 12 * oct);
  const chroma2 = (dir * (SIZES[step] + alt) % 12 + 12) % 12;
  const coord = coordinates({ step, alt, oct, dir });
  return {
    empty: false,
    name,
    num,
    q,
    step,
    alt,
    dir,
    type,
    simple,
    semitones: semitones2,
    chroma: chroma2,
    coord,
    oct
  };
}
function coordToInterval(coord, forceDescending) {
  const [f, o = 0] = coord;
  const isDescending = f * 7 + o * 12 < 0;
  const ivl = forceDescending || isDescending ? [-f, -o, -1] : [f, o, 1];
  return interval(pitch(ivl));
}
function qToAlt(type, q) {
  return q === "M" && type === "majorable" || q === "P" && type === "perfectable" ? 0 : q === "m" && type === "majorable" ? -1 : /^A+$/.test(q) ? q.length : /^d+$/.test(q) ? -1 * (type === "perfectable" ? q.length : q.length + 1) : 0;
}
function pitchName(props) {
  const { step, alt, oct = 0, dir } = props;
  if (!dir) {
    return "";
  }
  const calcNum = step + 1 + 7 * oct;
  const num = calcNum === 0 ? step + 1 : calcNum;
  const d = dir < 0 ? "-" : "";
  const type = TYPES[step] === "M" ? "majorable" : "perfectable";
  const name = d + num + altToQ(type, alt);
  return name;
}
function altToQ(type, alt) {
  if (alt === 0) {
    return type === "majorable" ? "M" : "P";
  } else if (alt === -1 && type === "majorable") {
    return "m";
  } else if (alt > 0) {
    return fillStr("A", alt);
  } else {
    return fillStr("d", type === "perfectable" ? alt : alt + 1);
  }
}

// ../../node_modules/@tonaljs/pitch-note/dist/index.mjs
var fillStr2 = (s, n) => Array(Math.abs(n) + 1).join(s);
var NoNote = Object.freeze({
  empty: true,
  name: "",
  letter: "",
  acc: "",
  pc: "",
  step: NaN,
  alt: NaN,
  chroma: NaN,
  height: NaN,
  coord: [],
  midi: null,
  freq: null
});
var cache2 = /* @__PURE__ */ new Map();
var stepToLetter = (step) => "CDEFGAB".charAt(step);
var altToAcc = (alt) => alt < 0 ? fillStr2("b", -alt) : fillStr2("#", alt);
var accToAlt = (acc) => acc[0] === "b" ? -acc.length : acc.length;
function note(src) {
  const stringSrc = JSON.stringify(src);
  const cached = cache2.get(stringSrc);
  if (cached) {
    return cached;
  }
  const value = typeof src === "string" ? parse2(src) : isPitch(src) ? note(pitchName2(src)) : isNamedPitch(src) ? note(src.name) : NoNote;
  cache2.set(stringSrc, value);
  return value;
}
var REGEX2 = /^([a-gA-G]?)(#{1,}|b{1,}|x{1,}|)(-?\d*)\s*(.*)$/;
function tokenizeNote(str) {
  const m = REGEX2.exec(str);
  return m ? [m[1].toUpperCase(), m[2].replace(/x/g, "##"), m[3], m[4]] : ["", "", "", ""];
}
function coordToNote(noteCoord) {
  return note(pitch(noteCoord));
}
var mod = (n, m) => (n % m + m) % m;
var SEMI = [0, 2, 4, 5, 7, 9, 11];
function parse2(noteName) {
  const tokens = tokenizeNote(noteName);
  if (tokens[0] === "" || tokens[3] !== "") {
    return NoNote;
  }
  const letter = tokens[0];
  const acc = tokens[1];
  const octStr = tokens[2];
  const step = (letter.charCodeAt(0) + 3) % 7;
  const alt = accToAlt(acc);
  const oct = octStr.length ? +octStr : void 0;
  const coord = coordinates({ step, alt, oct });
  const name = letter + acc + octStr;
  const pc = letter + acc;
  const chroma2 = (SEMI[step] + alt + 120) % 12;
  const height = oct === void 0 ? mod(SEMI[step] + alt, 12) - 12 * 99 : SEMI[step] + alt + 12 * (oct + 1);
  const midi = height >= 0 && height <= 127 ? height : null;
  const freq = oct === void 0 ? null : Math.pow(2, (height - 69) / 12) * 440;
  return {
    empty: false,
    acc,
    alt,
    chroma: chroma2,
    coord,
    freq,
    height,
    letter,
    midi,
    name,
    oct,
    pc,
    step
  };
}
function pitchName2(props) {
  const { step, alt, oct } = props;
  const letter = stepToLetter(step);
  if (!letter) {
    return "";
  }
  const pc = letter + altToAcc(alt);
  return oct || oct === 0 ? pc + oct : pc;
}

// ../../node_modules/@tonaljs/pitch-distance/dist/index.mjs
function transpose(noteName, intervalName) {
  const note2 = note(noteName);
  const intervalCoord = Array.isArray(intervalName) ? intervalName : interval(intervalName).coord;
  if (note2.empty || !intervalCoord || intervalCoord.length < 2) {
    return "";
  }
  const noteCoord = note2.coord;
  const tr = noteCoord.length === 1 ? [noteCoord[0] + intervalCoord[0]] : [noteCoord[0] + intervalCoord[0], noteCoord[1] + intervalCoord[1]];
  return coordToNote(tr).name;
}
function distance(fromNote, toNote) {
  const from = note(fromNote);
  const to = note(toNote);
  if (from.empty || to.empty) {
    return "";
  }
  const fcoord = from.coord;
  const tcoord = to.coord;
  const fifths = tcoord[0] - fcoord[0];
  const octs = fcoord.length === 2 && tcoord.length === 2 ? tcoord[1] - fcoord[1] : -Math.floor(fifths * 7 / 12);
  const forceDescending = to.height === from.height && to.midi !== null && from.oct === to.oct && from.step > to.step;
  return coordToInterval([fifths, octs], forceDescending).name;
}

// ../../node_modules/@tonaljs/pcset/dist/index.mjs
var EmptyPcset = {
  empty: true,
  name: "",
  setNum: 0,
  chroma: "000000000000",
  normalized: "000000000000",
  intervals: []
};
var setNumToChroma = (num2) => Number(num2).toString(2).padStart(12, "0");
var chromaToNumber = (chroma2) => parseInt(chroma2, 2);
var REGEX3 = /^[01]{12}$/;
function isChroma(set) {
  return REGEX3.test(set);
}
var isPcsetNum = (set) => typeof set === "number" && set >= 0 && set <= 4095;
var isPcset = (set) => set && isChroma(set.chroma);
var cache3 = { [EmptyPcset.chroma]: EmptyPcset };
function get(src) {
  const chroma2 = isChroma(src) ? src : isPcsetNum(src) ? setNumToChroma(src) : Array.isArray(src) ? listToChroma(src) : isPcset(src) ? src.chroma : EmptyPcset.chroma;
  return cache3[chroma2] = cache3[chroma2] || chromaToPcset(chroma2);
}
var chroma = (set) => get(set).chroma;
var IVLS = [
  "1P",
  "2m",
  "2M",
  "3m",
  "3M",
  "4P",
  "5d",
  "5P",
  "6m",
  "6M",
  "7m",
  "7M"
];
function chromaToIntervals(chroma2) {
  const intervals2 = [];
  for (let i = 0; i < 12; i++) {
    if (chroma2.charAt(i) === "1") intervals2.push(IVLS[i]);
  }
  return intervals2;
}
function modes(set, normalize = true) {
  const pcs = get(set);
  const binary = pcs.chroma.split("");
  return compact(
    binary.map((_, i) => {
      const r = rotate(i, binary);
      return normalize && r[0] === "0" ? null : r.join("");
    })
  );
}
function isSupersetOf(set) {
  const s = get(set).setNum;
  return (notes2) => {
    const o = get(notes2).setNum;
    return s && s !== o && (o | s) === o;
  };
}
function chromaRotations(chroma2) {
  const binary = chroma2.split("");
  return binary.map((_, i) => rotate(i, binary).join(""));
}
function chromaToPcset(chroma2) {
  const setNum = chromaToNumber(chroma2);
  const normalizedNum = chromaRotations(chroma2).map(chromaToNumber).filter((n) => n >= 2048).sort()[0];
  const normalized = setNumToChroma(normalizedNum);
  const intervals2 = chromaToIntervals(chroma2);
  return {
    empty: false,
    name: "",
    setNum,
    chroma: chroma2,
    normalized,
    intervals: intervals2
  };
}
function listToChroma(set) {
  if (set.length === 0) {
    return EmptyPcset.chroma;
  }
  let pitch2;
  const binary = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (let i = 0; i < set.length; i++) {
    pitch2 = note(set[i]);
    if (pitch2.empty) pitch2 = interval(set[i]);
    if (!pitch2.empty) binary[pitch2.chroma] = 1;
  }
  return binary.join("");
}

// ../../node_modules/@tonaljs/chord-type/dist/index.mjs
var CHORDS = [
  // ==Major==
  ["1P 3M 5P", "major", "M ^  maj"],
  ["1P 3M 5P 7M", "major seventh", "maj7 \u0394 ma7 M7 Maj7 ^7"],
  ["1P 3M 5P 7M 9M", "major ninth", "maj9 \u03949 ^9"],
  ["1P 3M 5P 7M 9M 13M", "major thirteenth", "maj13 Maj13 ^13"],
  ["1P 3M 5P 6M", "sixth", "6 add6 add13 M6"],
  ["1P 3M 5P 6M 9M", "sixth added ninth", "6add9 6/9 69 M69"],
  ["1P 3M 6m 7M", "major seventh flat sixth", "M7b6 ^7b6"],
  [
    "1P 3M 5P 7M 11A",
    "major seventh sharp eleventh",
    "maj#4 \u0394#4 \u0394#11 M7#11 ^7#11 maj7#11"
  ],
  // ==Minor==
  // '''Normal'''
  ["1P 3m 5P", "minor", "m min -"],
  ["1P 3m 5P 7m", "minor seventh", "m7 min7 mi7 -7"],
  [
    "1P 3m 5P 7M",
    "minor/major seventh",
    "m/ma7 m/maj7 mM7 mMaj7 m/M7 -\u03947 m\u0394 -^7 -maj7"
  ],
  ["1P 3m 5P 6M", "minor sixth", "m6 -6"],
  ["1P 3m 5P 7m 9M", "minor ninth", "m9 -9"],
  ["1P 3m 5P 7M 9M", "minor/major ninth", "mM9 mMaj9 -^9"],
  ["1P 3m 5P 7m 9M 11P", "minor eleventh", "m11 -11"],
  ["1P 3m 5P 7m 9M 13M", "minor thirteenth", "m13 -13"],
  // '''Diminished'''
  ["1P 3m 5d", "diminished", "dim \xB0 o"],
  ["1P 3m 5d 7d", "diminished seventh", "dim7 \xB07 o7"],
  ["1P 3m 5d 7m", "half-diminished", "m7b5 \xF8 -7b5 h7 h"],
  // ==Dominant/Seventh==
  // '''Normal'''
  ["1P 3M 5P 7m", "dominant seventh", "7 dom"],
  ["1P 3M 5P 7m 9M", "dominant ninth", "9"],
  ["1P 3M 5P 7m 9M 13M", "dominant thirteenth", "13"],
  ["1P 3M 5P 7m 11A", "lydian dominant seventh", "7#11 7#4"],
  // '''Altered'''
  ["1P 3M 5P 7m 9m", "dominant flat ninth", "7b9"],
  ["1P 3M 5P 7m 9A", "dominant sharp ninth", "7#9"],
  ["1P 3M 7m 9m", "altered", "alt7"],
  // '''Suspended'''
  ["1P 4P 5P", "suspended fourth", "sus4 sus"],
  ["1P 2M 5P", "suspended second", "sus2"],
  ["1P 4P 5P 7m", "suspended fourth seventh", "7sus4 7sus"],
  ["1P 5P 7m 9M 11P", "eleventh", "11"],
  [
    "1P 4P 5P 7m 9m",
    "suspended fourth flat ninth",
    "b9sus phryg 7b9sus 7b9sus4"
  ],
  // ==Other==
  ["1P 5P", "fifth", "5"],
  ["1P 3M 5A", "augmented", "aug + +5 ^#5"],
  ["1P 3m 5A", "minor augmented", "m#5 -#5 m+"],
  ["1P 3M 5A 7M", "augmented seventh", "maj7#5 maj7+5 +maj7 ^7#5"],
  [
    "1P 3M 5P 7M 9M 11A",
    "major sharp eleventh (lydian)",
    "maj9#11 \u03949#11 ^9#11"
  ],
  // ==Legacy==
  ["1P 2M 4P 5P", "", "sus24 sus4add9"],
  ["1P 3M 5A 7M 9M", "", "maj9#5 Maj9#5"],
  ["1P 3M 5A 7m", "", "7#5 +7 7+ 7aug aug7"],
  ["1P 3M 5A 7m 9A", "", "7#5#9 7#9#5 7alt"],
  ["1P 3M 5A 7m 9M", "", "9#5 9+"],
  ["1P 3M 5A 7m 9M 11A", "", "9#5#11"],
  ["1P 3M 5A 7m 9m", "", "7#5b9 7b9#5"],
  ["1P 3M 5A 7m 9m 11A", "", "7#5b9#11"],
  ["1P 3M 5A 9A", "", "+add#9"],
  ["1P 3M 5A 9M", "", "M#5add9 +add9"],
  ["1P 3M 5P 6M 11A", "", "M6#11 M6b5 6#11 6b5"],
  ["1P 3M 5P 6M 7M 9M", "", "M7add13"],
  ["1P 3M 5P 6M 9M 11A", "", "69#11"],
  ["1P 3m 5P 6M 9M", "", "m69 -69"],
  ["1P 3M 5P 6m 7m", "", "7b6"],
  ["1P 3M 5P 7M 9A 11A", "", "maj7#9#11"],
  ["1P 3M 5P 7M 9M 11A 13M", "", "M13#11 maj13#11 M13+4 M13#4"],
  ["1P 3M 5P 7M 9m", "", "M7b9"],
  ["1P 3M 5P 7m 11A 13m", "", "7#11b13 7b5b13"],
  ["1P 3M 5P 7m 13M", "", "7add6 67 7add13"],
  ["1P 3M 5P 7m 9A 11A", "", "7#9#11 7b5#9 7#9b5"],
  ["1P 3M 5P 7m 9A 11A 13M", "", "13#9#11"],
  ["1P 3M 5P 7m 9A 11A 13m", "", "7#9#11b13"],
  ["1P 3M 5P 7m 9A 13M", "", "13#9"],
  ["1P 3M 5P 7m 9A 13m", "", "7#9b13"],
  ["1P 3M 5P 7m 9M 11A", "", "9#11 9+4 9#4"],
  ["1P 3M 5P 7m 9M 11A 13M", "", "13#11 13+4 13#4"],
  ["1P 3M 5P 7m 9M 11A 13m", "", "9#11b13 9b5b13"],
  ["1P 3M 5P 7m 9m 11A", "", "7b9#11 7b5b9 7b9b5"],
  ["1P 3M 5P 7m 9m 11A 13M", "", "13b9#11"],
  ["1P 3M 5P 7m 9m 11A 13m", "", "7b9b13#11 7b9#11b13 7b5b9b13"],
  ["1P 3M 5P 7m 9m 13M", "", "13b9"],
  ["1P 3M 5P 7m 9m 13m", "", "7b9b13"],
  ["1P 3M 5P 7m 9m 9A", "", "7b9#9"],
  ["1P 3M 5P 9M", "", "Madd9 2 add9 add2"],
  ["1P 3M 5P 9m", "", "Maddb9"],
  ["1P 3M 5d", "", "Mb5"],
  ["1P 3M 5d 6M 7m 9M", "", "13b5"],
  ["1P 3M 5d 7M", "", "M7b5"],
  ["1P 3M 5d 7M 9M", "", "M9b5"],
  ["1P 3M 5d 7m", "", "7b5"],
  ["1P 3M 5d 7m 9M", "", "9b5"],
  ["1P 3M 7m", "", "7no5"],
  ["1P 3M 7m 13m", "", "7b13"],
  ["1P 3M 7m 9M", "", "9no5"],
  ["1P 3M 7m 9M 13M", "", "13no5"],
  ["1P 3M 7m 9M 13m", "", "9b13"],
  ["1P 3m 4P 5P", "", "madd4"],
  ["1P 3m 5P 6m 7M", "", "mMaj7b6"],
  ["1P 3m 5P 6m 7M 9M", "", "mMaj9b6"],
  ["1P 3m 5P 7m 11P", "", "m7add11 m7add4"],
  ["1P 3m 5P 9M", "", "madd9"],
  ["1P 3m 5d 6M 7M", "", "o7M7"],
  ["1P 3m 5d 7M", "", "oM7"],
  ["1P 3m 6m 7M", "", "mb6M7"],
  ["1P 3m 6m 7m", "", "m7#5"],
  ["1P 3m 6m 7m 9M", "", "m9#5"],
  ["1P 3m 5A 7m 9M 11P", "", "m11A"],
  ["1P 3m 6m 9m", "", "mb6b9"],
  ["1P 2M 3m 5d 7m", "", "m9b5"],
  ["1P 4P 5A 7M", "", "M7#5sus4"],
  ["1P 4P 5A 7M 9M", "", "M9#5sus4"],
  ["1P 4P 5A 7m", "", "7#5sus4"],
  ["1P 4P 5P 7M", "", "M7sus4"],
  ["1P 4P 5P 7M 9M", "", "M9sus4"],
  ["1P 4P 5P 7m 9M", "", "9sus4 9sus"],
  ["1P 4P 5P 7m 9M 13M", "", "13sus4 13sus"],
  ["1P 4P 5P 7m 9m 13m", "", "7sus4b9b13 7b9b13sus4"],
  ["1P 4P 7m 10m", "", "4 quartal"],
  ["1P 5P 7m 9m 11P", "", "11b9"]
];
var data_default = CHORDS;
var NoChordType = __spreadProps(__spreadValues({}, EmptyPcset), {
  name: "",
  quality: "Unknown",
  intervals: [],
  aliases: []
});
var dictionary = [];
var index = {};
function all() {
  return dictionary.slice();
}
function add(intervals, aliases, fullName) {
  const quality = getQuality(intervals);
  const chord = __spreadProps(__spreadValues({}, get(intervals)), {
    name: fullName || "",
    quality,
    intervals,
    aliases
  });
  dictionary.push(chord);
  if (chord.name) {
    index[chord.name] = chord;
  }
  index[chord.setNum] = chord;
  index[chord.chroma] = chord;
  chord.aliases.forEach((alias) => addAlias(chord, alias));
}
function addAlias(chord, alias) {
  index[alias] = chord;
}
function getQuality(intervals) {
  const has = (interval2) => intervals.indexOf(interval2) !== -1;
  return has("5A") ? "Augmented" : has("3M") ? "Major" : has("5d") ? "Diminished" : has("3m") ? "Minor" : "Unknown";
}
data_default.forEach(
  ([ivls, fullName, names2]) => add(ivls.split(" "), names2.split(" "), fullName)
);
dictionary.sort((a, b) => a.setNum - b.setNum);

// ../../node_modules/@tonaljs/chord-detect/dist/index.mjs
var namedSet = (notes) => {
  const pcToName = notes.reduce((record, n) => {
    const chroma2 = note(n).chroma;
    if (chroma2 !== void 0) {
      record[chroma2] = record[chroma2] || note(n).name;
    }
    return record;
  }, {});
  return (chroma2) => pcToName[chroma2];
};
function detect(source, options = {}) {
  const notes = source.map((n) => note(n).pc).filter((x) => x);
  if (note.length === 0) {
    return [];
  }
  const found = findMatches(notes, 1, options);
  return found.filter((chord) => chord.weight).sort((a, b) => b.weight - a.weight).map((chord) => chord.name);
}
var BITMASK = {
  // 3m 000100000000
  // 3M 000010000000
  anyThirds: 384,
  // 5P 000000010000
  perfectFifth: 16,
  // 5d 000000100000
  // 5A 000000001000
  nonPerfectFifths: 40,
  anySeventh: 3
};
var testChromaNumber = (bitmask) => (chromaNumber) => Boolean(chromaNumber & bitmask);
var hasAnyThird = testChromaNumber(BITMASK.anyThirds);
var hasPerfectFifth = testChromaNumber(BITMASK.perfectFifth);
var hasAnySeventh = testChromaNumber(BITMASK.anySeventh);
var hasNonPerfectFifth = testChromaNumber(BITMASK.nonPerfectFifths);
function hasAnyThirdAndPerfectFifthAndAnySeventh(chordType) {
  const chromaNumber = parseInt(chordType.chroma, 2);
  return hasAnyThird(chromaNumber) && hasPerfectFifth(chromaNumber) && hasAnySeventh(chromaNumber);
}
function withPerfectFifth(chroma2) {
  const chromaNumber = parseInt(chroma2, 2);
  return hasNonPerfectFifth(chromaNumber) ? chroma2 : (chromaNumber | 16).toString(2);
}
function findMatches(notes, weight, options) {
  const tonic = notes[0];
  const tonicChroma = note(tonic).chroma;
  const noteName = namedSet(notes);
  const allModes = modes(notes, false);
  const found = [];
  allModes.forEach((mode, index3) => {
    const modeWithPerfectFifth = options.assumePerfectFifth && withPerfectFifth(mode);
    const chordTypes = all().filter((chordType) => {
      if (options.assumePerfectFifth && hasAnyThirdAndPerfectFifthAndAnySeventh(chordType)) {
        return chordType.chroma === modeWithPerfectFifth;
      }
      return chordType.chroma === mode;
    });
    chordTypes.forEach((chordType) => {
      const chordName = chordType.aliases[0];
      const baseNote = noteName(index3);
      const isInversion = index3 !== tonicChroma;
      if (isInversion) {
        found.push({
          weight: 0.5 * weight,
          name: `${baseNote}${chordName}/${tonic}`
        });
      } else {
        found.push({ weight: 1 * weight, name: `${baseNote}${chordName}` });
      }
    });
  });
  return found;
}

// ../../node_modules/@tonaljs/interval/dist/index.mjs
var semitones = (name2) => interval(name2).semitones;
var IQ = "P m M m M P d P m M m M".split(" ");
var distance2 = distance;
var add2 = combinator((a, b) => [a[0] + b[0], a[1] + b[1]]);
var subtract = combinator((a, b) => [a[0] - b[0], a[1] - b[1]]);
function combinator(fn) {
  return (a, b) => {
    const coordA = interval(a).coord;
    const coordB = interval(b).coord;
    if (coordA && coordB) {
      const coord = fn(coordA, coordB);
      return coordToInterval(coord).name;
    }
  };
}

// ../../node_modules/@tonaljs/scale-type/dist/index.mjs
var SCALES = [
  // Basic scales
  ["1P 2M 3M 5P 6M", "major pentatonic", "pentatonic"],
  ["1P 2M 3M 4P 5P 6M 7M", "major", "ionian"],
  ["1P 2M 3m 4P 5P 6m 7m", "minor", "aeolian"],
  // Jazz common scales
  ["1P 2M 3m 3M 5P 6M", "major blues"],
  ["1P 3m 4P 5d 5P 7m", "minor blues", "blues"],
  ["1P 2M 3m 4P 5P 6M 7M", "melodic minor"],
  ["1P 2M 3m 4P 5P 6m 7M", "harmonic minor"],
  ["1P 2M 3M 4P 5P 6M 7m 7M", "bebop"],
  ["1P 2M 3m 4P 5d 6m 6M 7M", "diminished", "whole-half diminished"],
  // Modes
  ["1P 2M 3m 4P 5P 6M 7m", "dorian"],
  ["1P 2M 3M 4A 5P 6M 7M", "lydian"],
  ["1P 2M 3M 4P 5P 6M 7m", "mixolydian", "dominant"],
  ["1P 2m 3m 4P 5P 6m 7m", "phrygian"],
  ["1P 2m 3m 4P 5d 6m 7m", "locrian"],
  // 5-note scales
  ["1P 3M 4P 5P 7M", "ionian pentatonic"],
  ["1P 3M 4P 5P 7m", "mixolydian pentatonic", "indian"],
  ["1P 2M 4P 5P 6M", "ritusen"],
  ["1P 2M 4P 5P 7m", "egyptian"],
  ["1P 3M 4P 5d 7m", "neopolitan major pentatonic"],
  ["1P 3m 4P 5P 6m", "vietnamese 1"],
  ["1P 2m 3m 5P 6m", "pelog"],
  ["1P 2m 4P 5P 6m", "kumoijoshi"],
  ["1P 2M 3m 5P 6m", "hirajoshi"],
  ["1P 2m 4P 5d 7m", "iwato"],
  ["1P 2m 4P 5P 7m", "in-sen"],
  ["1P 3M 4A 5P 7M", "lydian pentatonic", "chinese"],
  ["1P 3m 4P 6m 7m", "malkos raga"],
  ["1P 3m 4P 5d 7m", "locrian pentatonic", "minor seven flat five pentatonic"],
  ["1P 3m 4P 5P 7m", "minor pentatonic", "vietnamese 2"],
  ["1P 3m 4P 5P 6M", "minor six pentatonic"],
  ["1P 2M 3m 5P 6M", "flat three pentatonic", "kumoi"],
  ["1P 2M 3M 5P 6m", "flat six pentatonic"],
  ["1P 2m 3M 5P 6M", "scriabin"],
  ["1P 3M 5d 6m 7m", "whole tone pentatonic"],
  ["1P 3M 4A 5A 7M", "lydian #5P pentatonic"],
  ["1P 3M 4A 5P 7m", "lydian dominant pentatonic"],
  ["1P 3m 4P 5P 7M", "minor #7M pentatonic"],
  ["1P 3m 4d 5d 7m", "super locrian pentatonic"],
  // 6-note scales
  ["1P 2M 3m 4P 5P 7M", "minor hexatonic"],
  ["1P 2A 3M 5P 5A 7M", "augmented"],
  ["1P 2M 4P 5P 6M 7m", "piongio"],
  ["1P 2m 3M 4A 6M 7m", "prometheus neopolitan"],
  ["1P 2M 3M 4A 6M 7m", "prometheus"],
  ["1P 2m 3M 5d 6m 7m", "mystery #1"],
  ["1P 2m 3M 4P 5A 6M", "six tone symmetric"],
  ["1P 2M 3M 4A 5A 6A", "whole tone", "messiaen's mode #1"],
  ["1P 2m 4P 4A 5P 7M", "messiaen's mode #5"],
  // 7-note scales
  ["1P 2M 3M 4P 5d 6m 7m", "locrian major", "arabian"],
  ["1P 2m 3M 4A 5P 6m 7M", "double harmonic lydian"],
  [
    "1P 2m 2A 3M 4A 6m 7m",
    "altered",
    "super locrian",
    "diminished whole tone",
    "pomeroy"
  ],
  ["1P 2M 3m 4P 5d 6m 7m", "locrian #2", "half-diminished", "aeolian b5"],
  [
    "1P 2M 3M 4P 5P 6m 7m",
    "mixolydian b6",
    "melodic minor fifth mode",
    "hindu"
  ],
  ["1P 2M 3M 4A 5P 6M 7m", "lydian dominant", "lydian b7", "overtone"],
  ["1P 2M 3M 4A 5A 6M 7M", "lydian augmented"],
  [
    "1P 2m 3m 4P 5P 6M 7m",
    "dorian b2",
    "phrygian #6",
    "melodic minor second mode"
  ],
  [
    "1P 2m 3m 4d 5d 6m 7d",
    "ultralocrian",
    "superlocrian bb7",
    "superlocrian diminished"
  ],
  ["1P 2m 3m 4P 5d 6M 7m", "locrian 6", "locrian natural 6", "locrian sharp 6"],
  ["1P 2A 3M 4P 5P 5A 7M", "augmented heptatonic"],
  // Source https://en.wikipedia.org/wiki/Ukrainian_Dorian_scale
  [
    "1P 2M 3m 4A 5P 6M 7m",
    "dorian #4",
    "ukrainian dorian",
    "romanian minor",
    "altered dorian"
  ],
  ["1P 2M 3m 4A 5P 6M 7M", "lydian diminished"],
  ["1P 2M 3M 4A 5A 7m 7M", "leading whole tone"],
  ["1P 2M 3M 4A 5P 6m 7m", "lydian minor"],
  ["1P 2m 3M 4P 5P 6m 7m", "phrygian dominant", "spanish", "phrygian major"],
  ["1P 2m 3m 4P 5P 6m 7M", "balinese"],
  ["1P 2m 3m 4P 5P 6M 7M", "neopolitan major"],
  ["1P 2M 3M 4P 5P 6m 7M", "harmonic major"],
  ["1P 2m 3M 4P 5P 6m 7M", "double harmonic major", "gypsy"],
  ["1P 2M 3m 4A 5P 6m 7M", "hungarian minor"],
  ["1P 2A 3M 4A 5P 6M 7m", "hungarian major"],
  ["1P 2m 3M 4P 5d 6M 7m", "oriental"],
  ["1P 2m 3m 3M 4A 5P 7m", "flamenco"],
  ["1P 2m 3m 4A 5P 6m 7M", "todi raga"],
  ["1P 2m 3M 4P 5d 6m 7M", "persian"],
  ["1P 2m 3M 5d 6m 7m 7M", "enigmatic"],
  [
    "1P 2M 3M 4P 5A 6M 7M",
    "major augmented",
    "major #5",
    "ionian augmented",
    "ionian #5"
  ],
  ["1P 2A 3M 4A 5P 6M 7M", "lydian #9"],
  // 8-note scales
  ["1P 2m 2M 4P 4A 5P 6m 7M", "messiaen's mode #4"],
  ["1P 2m 3M 4P 4A 5P 6m 7M", "purvi raga"],
  ["1P 2m 3m 3M 4P 5P 6m 7m", "spanish heptatonic"],
  ["1P 2M 3m 3M 4P 5P 6M 7m", "bebop minor"],
  ["1P 2M 3M 4P 5P 5A 6M 7M", "bebop major"],
  ["1P 2m 3m 4P 5d 5P 6m 7m", "bebop locrian"],
  ["1P 2M 3m 4P 5P 6m 7m 7M", "minor bebop"],
  ["1P 2M 3M 4P 5d 5P 6M 7M", "ichikosucho"],
  ["1P 2M 3m 4P 5P 6m 6M 7M", "minor six diminished"],
  [
    "1P 2m 3m 3M 4A 5P 6M 7m",
    "half-whole diminished",
    "dominant diminished",
    "messiaen's mode #2"
  ],
  ["1P 3m 3M 4P 5P 6M 7m 7M", "kafi raga"],
  ["1P 2M 3M 4P 4A 5A 6A 7M", "messiaen's mode #6"],
  // 9-note scales
  ["1P 2M 3m 3M 4P 5d 5P 6M 7m", "composite blues"],
  ["1P 2M 3m 3M 4A 5P 6m 7m 7M", "messiaen's mode #3"],
  // 10-note scales
  ["1P 2m 2M 3m 4P 4A 5P 6m 6M 7M", "messiaen's mode #7"],
  // 12-note scales
  ["1P 2m 2M 3m 3M 4P 5d 5P 6m 6M 7m 7M", "chromatic"]
];
var data_default2 = SCALES;
var NoScaleType = __spreadProps(__spreadValues({}, EmptyPcset), {
  intervals: [],
  aliases: []
});
var dictionary2 = [];
var index2 = {};
function get2(type) {
  return index2[type] || NoScaleType;
}
function all2() {
  return dictionary2.slice();
}
function add3(intervals, name, aliases = []) {
  const scale = __spreadProps(__spreadValues({}, get(intervals)), { name, intervals, aliases });
  dictionary2.push(scale);
  index2[scale.name] = scale;
  index2[scale.setNum] = scale;
  index2[scale.chroma] = scale;
  scale.aliases.forEach((alias) => addAlias2(scale, alias));
  return scale;
}
function addAlias2(scale, alias) {
  index2[alias] = scale;
}
data_default2.forEach(
  ([ivls, name, ...aliases]) => add3(ivls.split(" "), name, aliases)
);

// src/music-theory-service/utils/chords.ts
function findChords(notes) {
  return detect(notes);
}

// src/music-theory-service/utils/intervals.ts
function getInterval(noteA, noteB) {
  return distance2(noteA, noteB);
}
function formatTraditionalInterval(interval2) {
  if (!interval2) {
    return "?";
  }
  if (interval2.trim() === "") {
    return "?";
  }
  if (interval2.length >= 2) {
    let numberPart = "";
    let qualityPart = "";
    let i = 0;
    while (i < interval2.length && /\d/.test(interval2[i])) {
      numberPart += interval2[i];
      i++;
    }
    qualityPart = interval2.substring(i);
    return qualityPart + numberPart;
  }
  return "?";
}

// ../../node_modules/@tonaljs/midi/dist/index.mjs
var L2 = Math.log(2);
var L440 = Math.log(440);
var SHARPS = "C C# D D# E F F# G G# A A# B".split(" ");
var FLATS = "C Db D Eb E F Gb G Ab A Bb B".split(" ");
function midiToNoteName(midi, options = {}) {
  if (isNaN(midi) || midi === -Infinity || midi === Infinity) return "";
  midi = Math.round(midi);
  const pcs = options.sharps === true ? SHARPS : FLATS;
  const pc = pcs[midi % 12];
  if (options.pitchClass) {
    return pc;
  }
  const o = Math.floor(midi / 12) - 1;
  return pc + o;
}

// ../../node_modules/@tonaljs/note/dist/index.mjs
var get4 = note;
var transpose2 = transpose;
function enharmonic(noteName, destName) {
  const src = get4(noteName);
  if (src.empty) {
    return "";
  }
  const dest = get4(
    destName || midiToNoteName(src.midi || src.chroma, {
      sharps: src.alt < 0,
      pitchClass: true
    })
  );
  if (dest.empty || dest.chroma !== src.chroma) {
    return "";
  }
  if (src.oct === void 0) {
    return dest.pc;
  }
  const srcChroma = src.chroma - src.alt;
  const destChroma = dest.chroma - dest.alt;
  const destOctOffset = srcChroma > 11 || destChroma < 0 ? -1 : srcChroma < 0 || destChroma > 11 ? 1 : 0;
  const destOct = src.oct + destOctOffset;
  return dest.pc + destOct;
}

// ../../node_modules/@tonaljs/roman-numeral/dist/index.mjs
var NoRomanNumeral = { empty: true, name: "", chordType: "" };
var cache4 = {};
function get5(src) {
  return typeof src === "string" ? cache4[src] || (cache4[src] = parse3(src)) : typeof src === "number" ? get5(NAMES[src] || "") : isPitch(src) ? fromPitch(src) : isNamedPitch(src) ? get5(src.name) : NoRomanNumeral;
}
function fromPitch(pitch2) {
  return get5(altToAcc(pitch2.alt) + NAMES[pitch2.step]);
}
var REGEX4 = /^(#{1,}|b{1,}|x{1,}|)(IV|I{1,3}|VI{0,2}|iv|i{1,3}|vi{0,2})([^IViv]*)$/;
function tokenize(str) {
  return REGEX4.exec(str) || ["", "", "", ""];
}
var ROMANS = "I II III IV V VI VII";
var NAMES = ROMANS.split(" ");
var NAMES_MINOR = ROMANS.toLowerCase().split(" ");
function parse3(src) {
  const [name, acc, roman, chordType] = tokenize(src);
  if (!roman) {
    return NoRomanNumeral;
  }
  const upperRoman = roman.toUpperCase();
  const step = NAMES.indexOf(upperRoman);
  const alt = accToAlt(acc);
  const dir = 1;
  return {
    empty: false,
    name,
    roman,
    interval: interval({ step, alt, dir }).name,
    acc,
    chordType,
    alt,
    step,
    major: roman === upperRoman,
    oct: 0,
    dir
  };
}

// ../../node_modules/@tonaljs/key/dist/index.mjs
var Empty = Object.freeze([]);
var NoKey = {
  type: "major",
  tonic: "",
  alteration: 0,
  keySignature: ""
};
var NoKeyScale = {
  tonic: "",
  grades: Empty,
  intervals: Empty,
  scale: Empty,
  triads: Empty,
  chords: Empty,
  chordsHarmonicFunction: Empty,
  chordScales: Empty,
  secondaryDominants: Empty,
  secondaryDominantSupertonics: Empty,
  substituteDominantsMinorRelative: Empty,
  substituteDominants: Empty,
  substituteDominantSupertonics: Empty,
  secondaryDominantsMinorRelative: Empty
};
var NoMajorKey = __spreadProps(__spreadValues(__spreadValues({}, NoKey), NoKeyScale), {
  type: "major",
  minorRelative: "",
  scale: Empty,
  substituteDominants: Empty,
  secondaryDominantSupertonics: Empty,
  substituteDominantsMinorRelative: Empty
});
var NoMinorKey = __spreadProps(__spreadValues({}, NoKey), {
  type: "minor",
  relativeMajor: "",
  natural: NoKeyScale,
  harmonic: NoKeyScale,
  melodic: NoKeyScale
});
var mapScaleToType = (scale, list, sep = "") => list.map((type, i) => `${scale[i]}${sep}${type}`);
function keyScale(grades, triads, chordTypes, harmonicFunctions, chordScales) {
  return (tonic) => {
    const intervals = grades.map((gr) => get5(gr).interval || "");
    const scale = intervals.map((interval2) => transpose2(tonic, interval2));
    const chords = mapScaleToType(scale, chordTypes);
    const secondaryDominants = scale.map((note2) => transpose2(note2, "5P")).map(
      (note2) => (
        // A secondary dominant is a V chord which:
        // 1. is not diatonic to the key,
        // 2. it must have a diatonic root.
        scale.includes(note2) && !chords.includes(note2 + "7") ? note2 + "7" : ""
      )
    );
    const secondaryDominantSupertonics = supertonics(
      secondaryDominants,
      triads
    );
    const substituteDominants = secondaryDominants.map((chord) => {
      if (!chord) return "";
      const domRoot = chord.slice(0, -1);
      const subRoot = transpose2(domRoot, "5d");
      return subRoot + "7";
    });
    const substituteDominantSupertonics = supertonics(
      substituteDominants,
      triads
    );
    return {
      tonic,
      grades,
      intervals,
      scale,
      triads: mapScaleToType(scale, triads),
      chords,
      chordsHarmonicFunction: harmonicFunctions.slice(),
      chordScales: mapScaleToType(scale, chordScales, " "),
      secondaryDominants,
      secondaryDominantSupertonics,
      substituteDominants,
      substituteDominantSupertonics,
      // @deprecated use secondaryDominantsSupertonic
      secondaryDominantsMinorRelative: secondaryDominantSupertonics,
      // @deprecated use secondaryDominantsSupertonic
      substituteDominantsMinorRelative: substituteDominantSupertonics
    };
  };
}
var supertonics = (dominants, targetTriads) => {
  return dominants.map((chord, index3) => {
    if (!chord) return "";
    const domRoot = chord.slice(0, -1);
    const minorRoot = transpose2(domRoot, "5P");
    const target = targetTriads[index3];
    const isMinor = target.endsWith("m");
    return isMinor ? minorRoot + "m7" : minorRoot + "m7b5";
  });
};
var distInFifths = (from, to) => {
  const f = note(from);
  const t = note(to);
  return f.empty || t.empty ? 0 : t.coord[0] - f.coord[0];
};
var MajorScale = keyScale(
  "I II III IV V VI VII".split(" "),
  " m m   m dim".split(" "),
  "maj7 m7 m7 maj7 7 m7 m7b5".split(" "),
  "T SD T SD D T D".split(" "),
  "major,dorian,phrygian,lydian,mixolydian,minor,locrian".split(",")
);
var NaturalScale = keyScale(
  "I II bIII IV V bVI bVII".split(" "),
  "m dim  m m  ".split(" "),
  "m7 m7b5 maj7 m7 m7 maj7 7".split(" "),
  "T SD T SD D SD SD".split(" "),
  "minor,locrian,major,dorian,phrygian,lydian,mixolydian".split(",")
);
var HarmonicScale = keyScale(
  "I II bIII IV V bVI VII".split(" "),
  "m dim aug m   dim".split(" "),
  "mMaj7 m7b5 +maj7 m7 7 maj7 o7".split(" "),
  "T SD T SD D SD D".split(" "),
  "harmonic minor,locrian 6,major augmented,lydian diminished,phrygian dominant,lydian #9,ultralocrian".split(
    ","
  )
);
var MelodicScale = keyScale(
  "I II bIII IV V VI VII".split(" "),
  "m m aug   dim dim".split(" "),
  "m6 m7 +maj7 7 7 m7b5 m7b5".split(" "),
  "T SD T SD D  ".split(" "),
  "melodic minor,dorian b2,lydian augmented,lydian dominant,mixolydian b6,locrian #2,altered".split(
    ","
  )
);
function majorKey(tonic) {
  const pc = note(tonic).pc;
  if (!pc) return NoMajorKey;
  const keyScale2 = MajorScale(pc);
  const alteration = distInFifths("C", pc);
  return __spreadProps(__spreadValues({}, keyScale2), {
    type: "major",
    minorRelative: transpose2(pc, "-3m"),
    alteration,
    keySignature: altToAcc(alteration)
  });
}
function minorKey(tnc) {
  const pc = note(tnc).pc;
  if (!pc) return NoMinorKey;
  const alteration = distInFifths("C", pc) - 3;
  return {
    type: "minor",
    tonic: pc,
    relativeMajor: transpose2(pc, "3m"),
    alteration,
    keySignature: altToAcc(alteration),
    natural: NaturalScale(pc),
    harmonic: HarmonicScale(pc),
    melodic: MelodicScale(pc)
  };
}

// src/music-theory-service/utils/keys.ts
function getMajorKey(key) {
  return majorKey(key);
}
function getMinorKey(key) {
  return minorKey(key);
}

// src/errors/base.ts
var BaseError = class extends Error {
  constructor(message, code = "UNKNOWN_ERROR", details) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    this.details = details;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
};

// src/errors/core.ts
var CoreError = class extends BaseError {
  constructor(message, code = "CORE_ERROR", details) {
    super(message, code, details);
  }
};
var ValidationError = class extends CoreError {
  constructor(message, details) {
    super(message, "VALIDATION_ERROR", details);
  }
};
var NotFoundError = class extends CoreError {
  constructor(message = "Resource not found", details) {
    super(message, "NOT_FOUND", details);
  }
};

// src/music-theory-service/errors.ts
var TheoryServiceError = class extends BaseError {
  constructor(message, code = "THEORY_SERVICE_ERROR", details) {
    super(message, code, details);
  }
};

// src/music-theory-service/utils/notes.ts
function getEnharmonic(note2) {
  return enharmonic(note2);
}
function transposeNote(note2, interval2) {
  return transpose2(note2, interval2);
}
function areNotesEnharmonic(noteA, noteB) {
  if (noteA === noteB) return true;
  return noteA === enharmonic(noteB) || noteB === enharmonic(noteA);
}
function noteToScaleDegree(note2, rootNote, scaleType, getScaleNotesFunc) {
  try {
    const scaleNotes = getScaleNotesFunc(rootNote, scaleType);
    for (let i = 0; i < scaleNotes.length; i++) {
      if (areNotesEnharmonic(note2, scaleNotes[i])) {
        return String(i + 1);
      }
    }
    throw new ValidationError(`Note '${note2}' not found in scale '${rootNote} ${scaleType}'.`, {
      note: note2,
      rootNote,
      scaleType,
      availableScaleNotes: scaleNotes
    });
  } catch (error) {
    if (error instanceof ValidationError || error instanceof TheoryServiceError) {
      throw error;
    }
    if (error instanceof BaseError) {
      throw error;
    }
    const message = error instanceof Error ? error.message : String(error);
    throw new TheoryServiceError(
      `Error converting note to scale degree: ${message}`,
      "NOTE_TO_DEGREE_CONVERSION_FAILED",
      { originalError: error }
    );
  }
}

// ../../node_modules/@tonaljs/scale/dist/index.mjs
var NoScale = {
  empty: true,
  name: "",
  type: "",
  tonic: null,
  setNum: NaN,
  chroma: "",
  normalized: "",
  aliases: [],
  notes: [],
  intervals: []
};
function tokenize2(name) {
  if (typeof name !== "string") {
    return ["", ""];
  }
  const i = name.indexOf(" ");
  const tonic = note(name.substring(0, i));
  if (tonic.empty) {
    const n = note(name);
    return n.empty ? ["", name.toLowerCase()] : [n.name, ""];
  }
  const type = name.substring(tonic.name.length + 1).toLowerCase();
  return [tonic.name, type.length ? type : ""];
}
function get6(src) {
  const tokens = Array.isArray(src) ? src : tokenize2(src);
  const tonic = note(tokens[0]).name;
  const st = get2(tokens[1]);
  if (st.empty) {
    return NoScale;
  }
  const type = st.name;
  const notes = tonic ? st.intervals.map((i) => transpose(tonic, i)) : [];
  const name = tonic ? tonic + " " + type : type;
  return __spreadProps(__spreadValues({}, st), { name, type, tonic, notes });
}
function detect2(notes, options = {}) {
  var _a, _b;
  const notesChroma = chroma(notes);
  const tonic = note((_b = (_a = options.tonic) != null ? _a : notes[0]) != null ? _b : "");
  const tonicChroma = tonic.chroma;
  if (tonicChroma === void 0) {
    return [];
  }
  const pitchClasses = notesChroma.split("");
  pitchClasses[tonicChroma] = "1";
  const scaleChroma = rotate(tonicChroma, pitchClasses).join("");
  const match = all2().find((scaleType) => scaleType.chroma === scaleChroma);
  const results = [];
  if (match) {
    results.push(tonic.name + " " + match.name);
  }
  if (options.match === "exact") {
    return results;
  }
  extended(scaleChroma).forEach((scaleName) => {
    results.push(tonic.name + " " + scaleName);
  });
  return results;
}
function extended(name) {
  const chroma2 = isChroma(name) ? name : get6(name).chroma;
  const isSuperset = isSupersetOf(chroma2);
  return all2().filter((scale2) => isSuperset(scale2.chroma)).map((scale2) => scale2.name);
}

// src/music-theory-service/utils/scale-constants/interval-alterations.ts
var INTERVAL_TO_ALTERATION = {
  // Flat alterations
  "1d": "b",
  // diminished unison
  "2m": "b",
  // minor second
  "3m": "b",
  // minor third
  "4d": "b",
  // diminished fourth
  "5d": "b",
  // diminished fifth
  "6m": "b",
  // minor sixth
  "7m": "b",
  // minor seventh
  "8d": "b",
  // diminished octave
  // Double flat alterations
  "1dd": "bb",
  // double diminished unison
  "2d": "bb",
  // diminished second
  "3d": "bb",
  // diminished third
  "4dd": "bb",
  // double diminished fourth
  "5dd": "bb",
  // double diminished fifth
  "6d": "bb",
  // diminished sixth
  "7d": "bb",
  // diminished seventh
  // Sharp alterations
  "1A": "#",
  // augmented unison
  "2A": "#",
  // augmented second
  "3A": "#",
  // augmented third
  "4A": "#",
  // augmented fourth
  "5A": "#",
  // augmented fifth
  "6A": "#",
  // augmented sixth
  "7A": "#",
  // augmented seventh
  // Double sharp alterations
  "1AA": "##",
  // double augmented unison
  "2AA": "##",
  // double augmented second
  "3AA": "##",
  // double augmented third
  "4AA": "##",
  // double augmented fourth
  "5AA": "##",
  // double augmented fifth
  "6AA": "##",
  // double augmented sixth
  "7AA": "##"
  // double augmented seventh
};

// src/music-theory-service/utils/scale-calculations.ts
function calculateScaleDegrees(rootNote, _scaleType, areNotesEnharmonic2, getInterval2, scaleNotes, majorScaleNotes) {
  return scaleNotes.map((note2, index3) => {
    if (index3 === 0 || areNotesEnharmonic2(note2, rootNote)) {
      return {
        degree: 1,
        alteration: "",
        display: "1",
        semitones: 0
      };
    }
    const scaleDegree = index3 + 1;
    const majorIndex = index3 % majorScaleNotes.length;
    const majorScaleNote = majorScaleNotes[majorIndex];
    const interval2 = getInterval2(rootNote, note2);
    const semitones2 = semitones(interval2) || 0;
    if (!majorScaleNote) {
      return {
        degree: scaleDegree,
        alteration: "",
        display: String(scaleDegree),
        semitones: semitones2
      };
    }
    const comparisonInterval = getInterval2(majorScaleNote, note2);
    let alteration = "";
    if (comparisonInterval !== "1P") {
      alteration = INTERVAL_TO_ALTERATION[comparisonInterval] || "";
    }
    const actualDegree = majorIndex % 7 + 1;
    return {
      degree: actualDegree,
      alteration,
      display: `${alteration}${actualDegree}`,
      semitones: semitones2
    };
  });
}

// src/music-theory-service/utils/scale-constants/special-scales.ts
var SPECIAL_SCALES = {
  // Blues scale has a unique structure with duplicate 5th degree
  blues: {
    degrees: [
      { degree: 1, alteration: "", display: "1", semitones: 0 },
      { degree: 3, alteration: "b", display: "b3", semitones: 3 },
      { degree: 4, alteration: "", display: "4", semitones: 5 },
      { degree: 5, alteration: "b", display: "b5", semitones: 6 },
      { degree: 5, alteration: "", display: "5", semitones: 7 },
      { degree: 7, alteration: "b", display: "b7", semitones: 10 }
    ]
  },
  // Major pentatonic uses specific degrees from the major scale
  "major pentatonic": {
    degrees: [
      { degree: 1, alteration: "", display: "1", semitones: 0 },
      { degree: 2, alteration: "", display: "2", semitones: 2 },
      { degree: 3, alteration: "", display: "3", semitones: 4 },
      { degree: 5, alteration: "", display: "5", semitones: 7 },
      { degree: 6, alteration: "", display: "6", semitones: 9 }
    ]
  },
  // Minor pentatonic uses specific degrees from the natural minor scale
  "minor pentatonic": {
    degrees: [
      { degree: 1, alteration: "", display: "1", semitones: 0 },
      { degree: 3, alteration: "b", display: "b3", semitones: 3 },
      { degree: 4, alteration: "", display: "4", semitones: 5 },
      { degree: 5, alteration: "", display: "5", semitones: 7 },
      { degree: 7, alteration: "b", display: "b7", semitones: 10 }
    ]
  }
};

// src/music-theory-service/utils/scales.ts
function getScaleNotes(root, type) {
  try {
    const scale = get6(`${root} ${type}`);
    if (!scale.empty) {
      return scale.notes;
    }
    throw new TheoryServiceError(`Invalid scale: ${root} ${type}`);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new TheoryServiceError(`Error getting scale: ${message}`);
  }
}
function getScale(root, type) {
  try {
    const scale = get6(`${root} ${type}`);
    if (!scale.empty) {
      return scale;
    }
    throw new TheoryServiceError(`Invalid scale: ${root} ${type}`);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new TheoryServiceError(`Error getting scale: ${message}`);
  }
}
function findScales(notes) {
  return detect2(notes);
}
function getScaleDegreeInfo(rootNote, scaleType, areNotesEnharmonic2, getInterval2) {
  const normalizedScaleType = scaleType.toLowerCase();
  if (SPECIAL_SCALES[normalizedScaleType]) {
    return SPECIAL_SCALES[normalizedScaleType].degrees;
  }
  const scaleNotes = getScaleNotes(rootNote, scaleType);
  const majorScaleNotes = getScaleNotes(rootNote, "major");
  return calculateScaleDegrees(
    rootNote,
    scaleType,
    areNotesEnharmonic2,
    getInterval2,
    scaleNotes,
    majorScaleNotes
  );
}
function getScaleInfo(rootNote, scaleType, areNotesEnharmonic2, getInterval2, formatTraditionalInterval2) {
  const scaleNotes = getScaleNotes(rootNote, scaleType);
  const degreeInfo = getScaleDegreeInfo(rootNote, scaleType, areNotesEnharmonic2, getInterval2);
  const degrees = scaleNotes.map(
    (_, idx) => idx < degreeInfo.length ? degreeInfo[idx].display : String(idx + 1)
  );
  const standardDegrees = scaleNotes.map(
    (_, idx) => idx < degreeInfo.length ? degreeInfo[idx].degree : idx % 7 + 1
  );
  const semitones2 = scaleNotes.map(
    (note2, idx) => idx < degreeInfo.length ? degreeInfo[idx].semitones : semitones(getInterval2(rootNote, note2)) || 0
  );
  const stepPattern = [];
  for (let i = 0; i < scaleNotes.length - 1; i++) {
    const interval2 = getInterval2(scaleNotes[i], scaleNotes[i + 1]);
    if (interval2 === "2M") {
      stepPattern.push("W");
    } else if (interval2 === "2m" || interval2 === "1A") {
      stepPattern.push("H");
    } else if (interval2 === "3m") {
      stepPattern.push("m3");
    } else {
      stepPattern.push(formatTraditionalInterval2(interval2));
    }
  }
  return {
    notes: scaleNotes,
    degrees,
    standardDegrees,
    semitones: semitones2,
    stepPattern
  };
}

// src/music-theory-service/MusicTheoryService.ts
var MusicTheoryService = class {
  /**
   * Gets notes for a scale
   * @param root - Root note (e.g. "C", "F#")
   * @param type - Scale type (e.g. "major", "minor", "dorian")
   * @returns Array of note names
   */
  static getScaleNotes(root, type) {
    return getScaleNotes(root, type);
  }
  /**
   * Gets a complete scale object with additional properties
   * @param root - Root note (e.g. "C", "F#")
   * @param type - Scale type (e.g. "major", "minor", "dorian")
   * @returns Scale object from TonalJS
   */
  static getScale(root, type) {
    return getScale(root, type);
  }
  /**
   * Gets enharmonic equivalent of a note
   * @param note - Note name (e.g. "C#", "Db")
   * @returns Enharmonic note name
   */
  static getEnharmonic(note2) {
    return getEnharmonic(note2);
  }
  /**
   * Transposes a note by an interval
   * @param note - Note name (e.g. "C", "F#")
   * @param interval - Interval name (e.g. "P5", "M3", "m7")
   * @returns Resulting note name
   */
  static transposeNote(note2, interval2) {
    return transposeNote(note2, interval2);
  }
  /**
   * Gets the interval between two notes
   * @param noteA - First note
   * @param noteB - Second note
   * @returns Interval name
   */
  static getInterval(noteA, noteB) {
    return getInterval(noteA, noteB);
  }
  /**
   * Finds chords that contain the given notes
   * @param notes - Array of note names
   * @returns Array of possible chord names
   */
  static findChords(notes) {
    return findChords(notes);
  }
  /**
   * Finds scales that contain the given notes
   * @param notes - Array of note names
   * @returns Array of possible scale names
   */
  static findScales(notes) {
    return findScales(notes);
  }
  /**
   * Gets information about a key signature
   * @param key - Key name (e.g. "C", "A")
   * @returns Key object from TonalJS
   */
  static getMajorKey(key) {
    return getMajorKey(key);
  }
  /**
   * Gets information about a minor key signature
   * @param key - Key name (e.g. "Cm", "Am")
   * @returns Minor key object from TonalJS
   */
  static getMinorKey(key) {
    return getMinorKey(key);
  }
  /**
   * Check if two notes are enharmonically equivalent
   */
  static areNotesEnharmonic(noteA, noteB) {
    return areNotesEnharmonic(noteA, noteB);
  }
  /**
   * Converts interval notation from functional format (e.g., "3m") to traditional music theory format (e.g., "m3")
   * @param interval The interval in functional format (number first, quality second)
   * @returns The interval in traditional format (quality first, number second), or "?" if invalid
   */
  static formatTraditionalInterval(interval2) {
    return formatTraditionalInterval(interval2);
  }
  /**
   * Determines the scale degree (position) of a note within a scale
   * @param note The note to convert
   * @param rootNote The root note of the scale
   * @param scaleType The type of scale
   * @returns The scale degree as a string (1, 2, 3, etc.)
   */
  static noteToScaleDegree(note2, rootNote, scaleType) {
    return noteToScaleDegree(note2, rootNote, scaleType, this.getScaleNotes);
  }
  /**
   * Gets scale degree information for a scale
   * @param rootNote - Root note (e.g. "C", "F#")
   * @param scaleType - Scale type (e.g. "major", "minor", "pentatonic")
   * @returns Array of scale degree information objects
   */
  static getScaleDegreeInfo(rootNote, scaleType) {
    return getScaleDegreeInfo(rootNote, scaleType, this.areNotesEnharmonic, this.getInterval);
  }
  /**
   * Gets the scale degree with alteration prefixes (e.g., "b3", "#5")
   * @param note The note in the scale
   * @param index The index of the note in the scale (0-based)
   * @param rootNote The root note of the scale
   * @param scaleType The type of scale
   * @returns The scale degree with any alterations as a string (e.g., "1", "b3", "#5")
   */
  static getScaleDegreeWithAlteration(note2, index3, rootNote, scaleType) {
    if (index3 === 0 || this.areNotesEnharmonic(note2, rootNote)) {
      return "1";
    }
    const degreeInfo = this.getScaleDegreeInfo(rootNote, scaleType);
    if (index3 < degreeInfo.length) {
      return degreeInfo[index3].display;
    }
    return String(index3 + 1);
  }
  /**
   * Gets the standardized numeric scale degree (1-7) for a note in a scale
   * This is used for coloring and grouping scale degrees
   * @param note The note in the scale
   * @param index The index of the note (0-based)
   * @param rootNote The root note of the scale
   * @param scaleType The type of scale
   * @returns The standardized degree number (1-7)
   */
  static getStandardScaleDegree(note2, index3, rootNote, scaleType) {
    if (index3 === 0 || this.areNotesEnharmonic(note2, rootNote)) {
      return 1;
    }
    const degreeInfo = this.getScaleDegreeInfo(rootNote, scaleType);
    if (index3 < degreeInfo.length) {
      return degreeInfo[index3].degree;
    }
    return index3 % 7 + 1;
  }
  /**
   * Gets comprehensive information about a scale
   * @param rootNote The root note of the scale
   * @param scaleType The type of scale
   * @returns Object with detailed scale information
   */
  static getScaleInfo(rootNote, scaleType) {
    return getScaleInfo(
      rootNote,
      scaleType,
      this.areNotesEnharmonic,
      this.getInterval,
      this.formatTraditionalInterval
    );
  }
};

// src/music-theory-service/constants.ts
var ENHARMONIC_SHARP_TO_FLAT = {
  "C#": "Db",
  "D#": "Eb",
  "F#": "Gb",
  "G#": "Ab",
  "A#": "Bb"
};
var ENHARMONIC_FLAT_TO_SHARP = {
  Db: "C#",
  Eb: "D#",
  Gb: "F#",
  Ab: "G#",
  Bb: "A#"
};

// src/music-theory-service/types.ts
var InstrumentType = /* @__PURE__ */ ((InstrumentType3) => {
  InstrumentType3["Guitar"] = "Guitar";
  InstrumentType3["Bass"] = "Bass";
  InstrumentType3["Ukulele"] = "Ukulele";
  InstrumentType3["Mandolin"] = "Mandolin";
  InstrumentType3["Banjo"] = "Banjo";
  return InstrumentType3;
})(InstrumentType || {});
var ScaleNames = {
  Major: {
    value: "major",
    displayName: "Major"
  },
  Minor: {
    value: "minor",
    displayName: "Minor"
  },
  Dorian: {
    value: "dorian",
    displayName: "Dorian"
  },
  Phrygian: {
    value: "phrygian",
    displayName: "Phrygian"
  },
  Lydian: {
    value: "lydian",
    displayName: "Lydian"
  },
  Mixolydian: {
    value: "mixolydian",
    displayName: "Mixolydian"
  },
  Locrian: {
    value: "locrian",
    displayName: "Locrian"
  },
  MelodicMinor: {
    value: "melodic minor",
    displayName: "Melodic Minor"
  },
  HarmonicMinor: {
    value: "harmonic minor",
    displayName: "Harmonic Minor"
  },
  MajorPentatonic: {
    value: "major pentatonic",
    displayName: "Major Pentatonic"
  },
  MinorPentatonic: {
    value: "minor pentatonic",
    displayName: "Minor Pentatonic"
  },
  Blues: {
    value: "blues",
    displayName: "Blues"
  }
  // Add more as needed
};
var ChordNames = {
  Major: "major",
  Minor: "minor",
  Diminished: "diminished",
  Augmented: "augmented",
  Sus2: "sus2",
  Sus4: "sus4",
  Major7: "maj7",
  Minor7: "m7",
  Dominant7: "7",
  Diminished7: "dim7"
  // Add more as needed
};

// src/music-theory-service/instruments/banjo.ts
var BANJO_STANDARD_TUNING = {
  id: "banjo-standard",
  label: "Standard Open G (Banjo)",
  pitches: [
    { note: "G", octave: 4 },
    { note: "D", octave: 3 },
    { note: "G", octave: 3 },
    { note: "B", octave: 3 },
    { note: "D", octave: 4 }
  ]
};
var BANJO_DEFINITION = {
  type: "Banjo" /* Banjo */,
  name: "Banjo",
  defaultNumFrets: 22,
  defaultTunings: [BANJO_STANDARD_TUNING]
};

// src/music-theory-service/instruments/bass.ts
var BASS_STANDARD_TUNING = {
  id: "bass-standard",
  label: "Standard (Bass)",
  pitches: [
    { note: "G", octave: 2 },
    { note: "D", octave: 2 },
    { note: "A", octave: 1 },
    { note: "E", octave: 1 }
  ]
};
var BASS_DEFINITION = {
  type: "Bass" /* Bass */,
  name: "Bass",
  defaultNumFrets: 24,
  defaultTunings: [BASS_STANDARD_TUNING]
};

// src/music-theory-service/instruments/guitar.ts
var GUITAR_STANDARD_E_TUNING = {
  id: "guitar-standard-e",
  label: "Standard E (Guitar)",
  pitches: [
    { note: "E", octave: 4 },
    { note: "B", octave: 3 },
    { note: "G", octave: 3 },
    { note: "D", octave: 3 },
    { note: "A", octave: 2 },
    { note: "E", octave: 2 }
  ]
};
var GUITAR_DROP_D_TUNING = {
  id: "guitar-drop-d",
  label: "Drop D (Guitar)",
  pitches: [
    { note: "E", octave: 4 },
    { note: "B", octave: 3 },
    { note: "G", octave: 3 },
    { note: "D", octave: 3 },
    { note: "A", octave: 2 },
    { note: "D", octave: 2 }
  ]
};
var GUITAR_DEFINITION = {
  type: "Guitar" /* Guitar */,
  name: "Guitar",
  defaultNumFrets: 22,
  defaultTunings: [GUITAR_STANDARD_E_TUNING, GUITAR_DROP_D_TUNING]
};

// src/music-theory-service/instruments/mandolin.ts
var MANDOLIN_STANDARD_TUNING = {
  id: "mandolin-standard",
  label: "Standard (Mandolin)",
  pitches: [
    { note: "E", octave: 5 },
    { note: "A", octave: 4 },
    { note: "D", octave: 4 },
    { note: "G", octave: 3 }
  ]
};
var MANDOLIN_DEFINITION = {
  type: "Mandolin" /* Mandolin */,
  name: "Mandolin",
  defaultNumFrets: 20,
  defaultTunings: [MANDOLIN_STANDARD_TUNING]
};

// src/music-theory-service/instruments/ukulele.ts
var UKULELE_STANDARD_TUNING = {
  id: "ukulele-standard",
  label: "Standard (GCEA)",
  pitches: [
    { note: "A", octave: 4 },
    { note: "E", octave: 4 },
    { note: "C", octave: 4 },
    { note: "G", octave: 4 }
  ]
};
var UKULELE_BARITONE_TUNING = {
  id: "ukulele-baritone",
  label: "Baritone (DGBE)",
  pitches: [
    { note: "E", octave: 4 },
    { note: "B", octave: 3 },
    { note: "G", octave: 3 },
    { note: "D", octave: 3 }
  ]
};
var UKULELE_DEFINITION = {
  type: "Ukulele" /* Ukulele */,
  name: "Ukulele",
  defaultNumFrets: 12,
  defaultTunings: [UKULELE_STANDARD_TUNING, UKULELE_BARITONE_TUNING]
};

// src/music-theory-service/instruments/index.ts
var ALL_INSTRUMENTS = [
  GUITAR_DEFINITION,
  BASS_DEFINITION,
  UKULELE_DEFINITION,
  BANJO_DEFINITION,
  MANDOLIN_DEFINITION
];
function createInitialRecord() {
  const record = {
    Guitar: GUITAR_DEFINITION,
    Bass: BASS_DEFINITION,
    Ukulele: UKULELE_DEFINITION,
    Mandolin: MANDOLIN_DEFINITION,
    Banjo: BANJO_DEFINITION
  };
  return record;
}
var INSTRUMENTS_BY_TYPE = ALL_INSTRUMENTS.reduce((acc, instrument) => {
  acc[instrument.type] = instrument;
  return acc;
}, createInitialRecord());

// src/fretboard-model/FretboardModel.ts
var FretboardModel = class {
  /**
   * Constructs a new FretboardModel instance.
   *
   * @param {FretboardOptions} options - The options for configuring the fretboard.
   * @throws {Error} If the instrument type is unsupported or the tuning is invalid.
   */
  constructor(options) {
    var _a, _b;
    const instrumentDefinition = INSTRUMENTS_BY_TYPE[options.instrumentType];
    if (!instrumentDefinition) {
      throw new ValidationError(`Unsupported instrument type: ${options.instrumentType}`, {
        instrumentType: options.instrumentType
      });
    }
    this.instrument = instrumentDefinition;
    let selectedTuning;
    if (options.tuning) {
      const expectedLength = (_a = instrumentDefinition.defaultTunings[0]) == null ? void 0 : _a.pitches.length;
      if (!expectedLength || options.tuning.length !== expectedLength) {
        throw new ValidationError(
          "Custom tuning array length must match the expected number of strings for the instrument.",
          {
            expectedLength: expectedLength != null ? expectedLength : "unknown",
            actualLength: options.tuning.length,
            instrument: this.instrument.name
          }
        );
      }
      selectedTuning = {
        // Create a "custom" TuningDefinition
        id: "custom-tuning",
        label: "Custom Tuning",
        pitches: options.tuning
      };
    } else if (options.tuningId) {
      selectedTuning = this.instrument.defaultTunings.find((t) => t.id === options.tuningId);
      if (!selectedTuning) {
        throw new ValidationError(
          `Tuning with id '${options.tuningId}' not found for instrument '${this.instrument.name}'.`,
          {
            tuningId: options.tuningId,
            instrumentName: this.instrument.name
          }
        );
      }
    } else {
      selectedTuning = this.instrument.defaultTunings[0];
      if (!selectedTuning) {
        throw new CoreError(
          `No default tuning defined for instrument '${this.instrument.name}'.`,
          "MISSING_DEFAULT_TUNING",
          { instrumentName: this.instrument.name }
        );
      }
    }
    this.tuning = selectedTuning;
    this.numStrings = this.tuning.pitches.length;
    this.numFrets = (_b = options.numFrets) != null ? _b : this.instrument.defaultNumFrets;
    this.positions = this.initializePositions();
  }
  /**
   * Initializes the fretboard positions map.
   *
   * This private method is responsible for the core logic of calculating and storing
   * the musical note at each fret position on the fretboard. It iterates through each string
   * and fret, determining the corresponding note based on the fretboard's tuning.
   *
   * The calculated `FretPosition` objects are stored in the `positions` Map,
   * which serves as the central data structure for the fretboard model.
   *
   * @private
   * @returns {Map<string, FretPosition>} A Map where keys are position keys (string-fret)
   *                                      and values are {@link FretPosition} objects.
   *
   * @remarks
   * This method is called internally by the constructor to set up the fretboard's
   * note positions when a new `FretboardModel` instance is created.
   */
  initializePositions() {
    const positions = /* @__PURE__ */ new Map();
    const chromaticScale = [
      "C",
      "C#",
      "D",
      "D#",
      "E",
      "F",
      "F#",
      "G",
      "G#",
      "A",
      "A#",
      "B"
    ];
    for (let string = 0; string < this.numStrings; string++) {
      const openPitch = this.tuning.pitches[string];
      const openNoteName = openPitch.note;
      const openNoteOctave = openPitch.octave;
      const noteIndex = chromaticScale.findIndex(
        (note2) => (
          // Handle both exact matches and enharmonic equivalents
          note2 === openNoteName || MusicTheoryService.areNotesEnharmonic(note2, openNoteName)
        )
      );
      if (noteIndex === -1) {
        throw new CoreError(
          `Could not find note ${openNoteName} in chromatic scale`,
          "NOTE_LOOKUP_FAILED",
          { noteName: openNoteName }
        );
      }
      for (let fret = 0; fret <= this.numFrets; fret++) {
        let noteName;
        let noteOctave;
        if (fret === 0) {
          noteName = openNoteName;
          noteOctave = openNoteOctave;
        } else {
          const newNoteIndex = (noteIndex + fret) % 12;
          noteName = chromaticScale[newNoteIndex];
          const octaveIncrease = Math.floor((noteIndex + fret) / 12);
          noteOctave = openNoteOctave + octaveIncrease;
        }
        const position = {
          string,
          fret,
          pitch: {
            note: noteName,
            octave: noteOctave
          }
        };
        positions.set(this.getPositionKey(string, fret), position);
      }
    }
    return positions;
  }
  /**
   * Generates a unique string key for a given fretboard position.
   *
   * This utility method creates a consistent key format for storing and retrieving
   * `FretPosition` objects in the `positions` Map. The key is a combination of
   * the string index and fret number, separated by a hyphen.
   *
   * @param {number} string The string index (0-indexed, starting from the highest pitched string).
   * @param {number} fret The fret number (starting from 0 for the open string).
   * @returns {string} A string key representing the fret position, in the format "string-fret" (e.g., "0-12", "5-3").
   *
   * @example
   * ```typescript
   * const key = fretboardModel.getPositionKey(0, 5); // key will be "0-5"
   * ```
   */
  getPositionKey(string, fret) {
    return `${string}-${fret}`;
  }
  /**
   * Returns the dimensions of the fretboard.
   *
   * This method provides access to the number of strings and frets configured for this
   * `FretboardModel` instance. These dimensions are set during construction and are read-only
   * after initialization.
   *
   * @returns {{ numStrings: number; numFrets: number }} An object containing:
   *   - `numStrings`: The number of strings on the fretboard.
   *   - `numFrets`: The number of frets on the fretboard.
   *
   * @example
   * ```typescript
   * const dimensions = fretboardModel.getDimensions();
   * dimensions.numStrings // Output: 6 (or the configured number of strings)
   * dimensions.numFrets   // Output: 24 (or the configured number of frets)
   * ```
   */
  getDimensions() {
    return {
      numStrings: this.numStrings,
      numFrets: this.numFrets
    };
  }
  /**
   * Retrieves all fret positions on the fretboard.
   *
   * This method returns an array containing all {@link FretPosition} objects that have been
   * calculated and stored in the `positions` Map during initialization. This provides a
   * complete representation of all notes available on the fretboard.
   *
   * @returns {FretPosition[]} An array of {@link FretPosition} objects, representing all positions on the fretboard.
   *
   * @example
   * ```typescript
   * const allPositions = fretboardModel.getAllPositions();
   * allPositions.length // Output: (numStrings * (numFrets + 1)) - e.g., 150 for a 6-string, 24-fret board
   * allPositions[0]      // Output: The FretPosition object for the first position
   * ```
   */
  getAllPositions() {
    return Array.from(this.positions.values());
  }
  /**
   * Retrieves a specific fret position by string and fret number.
   *
   * This method allows you to access a specific {@link FretPosition} object based on its
   * string index and fret number. It uses the `getPositionKey()` method to construct the
   * key for looking up the position in the `positions` Map.
   *
   * @param {number} string The string index (0-indexed).
   * @param {number} fret The fret number.
   * @returns {FretPosition | undefined} The {@link FretPosition} object if a position exists for the given
   *                                    string and fret, otherwise `undefined`.
   *
   * @example
   * ```typescript
   * const positionE2 = fretboardModel.getPosition(5, 0); // Get the open 6th string (E2 in Standard E tuning)
   * if (positionE2) {
   *   positionE2.pitch.note; // Output: "E"
   *   positionE2.pitch.octave; // Output: 2
   * }
   *
   * const invalidPosition = fretboardModel.getPosition(100, 100); // String 100 and fret 100 are likely invalid
   * invalidPosition; // Output: undefined
   * ```
   */
  getPosition(string, fret) {
    return this.positions.get(this.getPositionKey(string, fret));
  }
  /**
   * Gets fret positions that belong to a given scale.
   *
   * @param {string} root The root note of the scale (e.g., "C", "F#")
   * @param {string} type The scale type (e.g., "major", "minor", "dorian")
   * @returns {FretPosition[]} An array of FretPosition objects that are part of the specified scale.
   *
   * @example
   * ```typescript
   * const fretboard = new FretboardModel();
   * const majorScalePositions = fretboard.getScalePositions("C", "major");
   * majorScalePositions // Array of FretPosition objects for C Major scale
   * ```
   */
  getScalePositions(root, type) {
    const scaleNotes = MusicTheoryService.getScaleNotes(root, type);
    return this.getAllPositions().filter(
      (pos) => scaleNotes.some(
        (scaleNote) => MusicTheoryService.areNotesEnharmonic(scaleNote, pos.pitch.note)
      )
    );
  }
  getRandomFretPosition(fretRange, activeStrings) {
    if (fretRange || activeStrings) {
      const allPositions = this.getAllPositions();
      const validPositions = allPositions.filter(
        (position2) => (
          // Apply fret range filter if provided
          (!fretRange || position2.fret >= fretRange.min && position2.fret <= fretRange.max) && // Apply active strings filter if provided
          (!activeStrings || activeStrings.includes(position2.string))
        )
      );
      if (validPositions.length > 0) {
        const randomIndex = Math.floor(Math.random() * validPositions.length);
        return validPositions[randomIndex];
      }
      return null;
    }
    const string = Math.floor(Math.random() * this.numStrings);
    const fret = Math.floor(Math.random() * this.numFrets);
    const position = this.getPosition(string, fret);
    if (!position) {
      throw new CoreError("Invalid position generated randomly.", "INTERNAL_LOGIC_ERROR", {
        generatedString: string,
        generatedFret: fret
      });
    }
    return position;
  }
  getInstrumentDefinition() {
    return this.instrument;
  }
  /**
   * Returns the number of strings on the instrument.
   *
   * @returns {number} The number of strings on the instrument.
   *
   * @example
   * ```typescript
   * const fretboard = new FretboardModel(options);
   * const numStrings = fretboard.getNumStrings(); // e.g., 6 for a standard guitar
   * ```
   */
  getNumStrings() {
    return this.numStrings;
  }
};

// src/fretboard-model/constants.ts
var FRET_MARKER_POSITIONS = [3, 5, 7, 9, 12, 15, 17, 19, 21, 24];

// src/scale-display/types.ts
var ScaleDisplayMode = /* @__PURE__ */ ((ScaleDisplayMode2) => {
  ScaleDisplayMode2["NOTE_NAMES"] = "NOTE_NAMES";
  ScaleDisplayMode2["SCALE_DEGREES"] = "SCALE_DEGREES";
  ScaleDisplayMode2["INTERVALS"] = "INTERVALS";
  return ScaleDisplayMode2;
})(ScaleDisplayMode || {});

// src/scale-display/utils/formatNote.ts
function formatNote(rootNote, note2, scaleIndex, scaleType, displayMode) {
  const functionalInterval = MusicTheoryService.getInterval(rootNote, note2);
  switch (displayMode) {
    case "SCALE_DEGREES" /* SCALE_DEGREES */:
      return MusicTheoryService.getScaleDegreeWithAlteration(note2, scaleIndex, rootNote, scaleType);
    case "INTERVALS" /* INTERVALS */:
      return MusicTheoryService.formatTraditionalInterval(functionalInterval);
    case "NOTE_NAMES" /* NOTE_NAMES */:
    default:
      return note2;
  }
}

// src/scale-display/utils/generateScaleVisualizationData.ts
function getCompleteScaleNotes(rootNote, scaleType) {
  const scaleNotes = MusicTheoryService.getScaleNotes(rootNote, scaleType);
  if (scaleNotes.length === 0) return [];
  return [...scaleNotes, scaleNotes[0]];
}
function getScaleStepPatterns(rootNote, scaleType) {
  const completeScaleNotes = getCompleteScaleNotes(rootNote, scaleType);
  if (completeScaleNotes.length < 2) return [];
  const patterns = [];
  const scaleInfo = MusicTheoryService.getScaleInfo(rootNote, scaleType);
  for (let i = 0; i < completeScaleNotes.length - 1; i++) {
    const currentNote = completeScaleNotes[i];
    const nextNote = completeScaleNotes[i + 1];
    const interval2 = MusicTheoryService.getInterval(currentNote, nextNote);
    let display;
    if (i >= scaleInfo.stepPattern.length) {
      if (interval2 === "2M") {
        display = "W";
      } else if (interval2 === "2m" || interval2 === "1A") {
        display = "H";
      } else {
        display = MusicTheoryService.formatTraditionalInterval(interval2);
      }
    } else {
      display = scaleInfo.stepPattern[i];
    }
    let description;
    if (interval2 === "2M") {
      description = "Whole step (2 semitones)";
    } else if (interval2 === "2m" || interval2 === "1A") {
      description = "Half step (1 semitone)";
    } else if (interval2 === "3m") {
      description = "Minor third (3 semitones)";
    } else if (interval2 === "3M") {
      description = "Major third (4 semitones)";
    } else if (interval2 === "4P") {
      description = "Perfect fourth (5 semitones)";
    } else if (interval2 === "5d") {
      description = "Diminished fifth (6 semitones)";
    } else if (interval2 === "5P") {
      description = "Perfect fifth (7 semitones)";
    } else if (interval2 === "6M") {
      description = "Major sixth (9 semitones)";
    } else if (interval2 === "7m") {
      description = "Minor seventh (10 semitones)";
    } else if (interval2 === "2A") {
      description = "Augmented second (3 semitones)";
    } else {
      description = "Unknown interval";
    }
    patterns.push({
      display,
      interval: interval2,
      description
    });
  }
  return patterns;
}
function generateScaleVisualizationData(rootNote, scaleType, displayMode) {
  const completeNotes = getCompleteScaleNotes(rootNote, scaleType);
  const stepPatterns = getScaleStepPatterns(rootNote, scaleType);
  const formattedNotes = completeNotes.map((note2, index3) => ({
    note: note2,
    formattedDisplay: formatNote(
      rootNote,
      note2,
      index3 === completeNotes.length - 1 ? 0 : index3,
      scaleType,
      displayMode
    ),
    isOctave: index3 === completeNotes.length - 1
  }));
  return {
    notes: formattedNotes,
    stepPatterns
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BaseError,
  ChordNames,
  CoreError,
  ENHARMONIC_FLAT_TO_SHARP,
  ENHARMONIC_SHARP_TO_FLAT,
  FRET_MARKER_POSITIONS,
  FretboardModel,
  INSTRUMENTS_BY_TYPE,
  InstrumentType,
  MusicTheoryService,
  NotFoundError,
  ScaleDisplayMode,
  ScaleNames,
  ValidationError,
  formatNote,
  generateScaleVisualizationData,
  getCompleteScaleNotes,
  getScaleStepPatterns
});
//# sourceMappingURL=index.js.map